import gql from 'graphql-tag'
import { EnumFields } from '..'

export const ValidationTypeFragment = gql`
  fragment ValidationType on settings_validation_type {
    ${EnumFields}
  }
`
